import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';
const Option = components.Option;
const SelectOption = _ref => {
  let children = _ref.children,
    optionProps = _objectWithoutProperties(_ref, _excluded);
  const allProps = _objectSpread(_objectSpread({}, optionProps), {}, {
    key: optionProps.data.id,
    className: "".concat(optionProps.data.className, " t-select-option")
  });
  return /*#__PURE__*/ /* eslint-disable-next-line react/jsx-props-no-spreading */React.createElement(Option, allProps, children, optionProps.data.subtitle ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", {
    style: {
      opacity: 0.8
    }
  }, optionProps.data.subtitle)) : null);
};
SelectOption.propTypes = {
  children: PropTypes.node.isRequired
};
export default SelectOption;